/**
 * BRE-7686: keeps a dialog's content no wider than the dialog. Grid and flex-row
 * items default to `min-width: auto`, so a long unbreakable or `truncate`d string
 * widened the track past `max-w-*` and pushed content and footer off the edge.
 * This drops that content-size floor from each DIRECT child (the dialog box
 * still sizes as before), so a fixed-width child in a flex-row override needs
 * `shrink-0`. `:where` keeps it at zero specificity so a child's own `min-w-*`
 * wins. `break-words` wraps a long word in flowing text; a deeper flex row or a
 * centered (`items-center`) column still needs its own `min-w-0` / `max-w-full`.
 */
export const DIALOG_CONTENT_FIT = "[:where(&)>*]:min-w-0 break-words";
